import {
  FETCH_CONSENT_MATRIX,
  FETCH_CONSENT_STATUS,
  UPDATE_CONSENTS,
  INITIATE_COUNTRY_CONFIRMATION,
  CANCEL_COUNTRY_CONFIRMATION,
  STAGE_UNCONSENTED_LIST,
  STAGE_CONSENT_SCREEN_NAME,
} from './constants'

export function initiateCountryConfirmation (country) {
  return (dispatch) => {
    return dispatch({
      type: INITIATE_COUNTRY_CONFIRMATION,
      payload: country,
    })
  }
}

export function cancelCountryConfirmation () {
  return (dispatch) => {
    return dispatch({
      type: CANCEL_COUNTRY_CONFIRMATION,
    })
  }
}

export function fetchConsentMatrix (isoCode) {
  return (dispatch, getState, { auth }) => {
    return dispatch({
      type: FETCH_CONSENT_MATRIX,
      payload: auth.getConsentMatrix(isoCode),
    })
  }
}

export function fetchConsentStatus (isoCode) {
  return (dispatch, getState, { auth }) => {
    return dispatch({
      type: FETCH_CONSENT_STATUS,
      payload: auth.getConsentStatus({ gdpr_iso_code: isoCode, content: true, expanded: true }),
    })
  }
}

// eslint-disable-line camelcase
export function updateConsents (consentMatrixVersion, country, consents) {
  return (dispatch, getState, { auth }) => {
    return dispatch({
      type: UPDATE_CONSENTS,
      // eslint-disable-line camelcase
      payload: auth.updateConsents({ consent_matrix_version: consentMatrixVersion,
        consents,
        region: country,
      }),
    })
  }
}

export function stageUnconsenteList (values) {
  return (dispatch) => {
    return dispatch({
      type: STAGE_UNCONSENTED_LIST,
      payload: values,
    })
  }
}

export function stageConsentSource (screeName) {
  return (dispatch) => {
    return dispatch({
      type: STAGE_CONSENT_SCREEN_NAME,
      payload: screeName,
    })
  }
}

export function clickExportDataHelp (screenName) {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      screen_name: screenName,
    }
    clientEventManager.logEvent('export_data_tapped', eventProps)
  }
}

export function clickDeleteAccount (screenName) {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      screen_name: screenName,
    }
    clientEventManager.logEvent('account_deleted', eventProps)
  }
}
